import type { FaireProductEntity } from "../../entity_types/product";

export const p_j9e4j8y3wp: FaireProductEntity = {
  token: "p_j9e4j8y3wp",
  type: "product",
  name: "MICKEY DINNER BOWL, 87917 FO",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/b4518d3dec0deba38c9c9618698b8cfb020315dde205cc4d8a1aaf7d0189170d.jpeg",
  galleryImageUrls: [],
  priceDollars: 8.66,
  description:
    "Introduce the Mickey Dinner Bowl from Joia Accessories to your dining experience. This dinnerware piece, perfect for fans of all ages, is manufactured with attention to quality, reflecting our 30-year legacy of delivering diverse and trend-forward fashion accessories. Enjoy your favorite dishes with this unique bowl!",
  tags: [],
  msrpDollars: 17.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:08.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
